/** @typedef {'error' | 'success'} ToastVariant */

/**
 * @typedef {Object} ToastPayload
 * @property {ToastVariant} variant
 * @property {string} message
 * @property {number} duration
 */

const listeners = new Set();

/**
 * @param {ToastPayload} payload
 */
function notify(payload) {
  listeners.forEach((fn) => fn(payload));
}

/**
 * @param {(payload: ToastPayload) => void} listener
 * @returns {() => void} unsubscribe
 */
export function subscribeToaster(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export const toaster = {
  /**
   * @param {{ variant?: ToastVariant, message: string, duration?: number }} options
   */
  show(options) {
    const message = options?.message?.trim();
    if (!message) return;

    notify({
      variant: options.variant ?? 'error',
      message,
      duration: options.duration ?? 5000,
    });
  },

  /**
   * @param {string} message
   * @param {number} [duration]
   */
  showError(message, duration) {
    this.show({ variant: 'error', message, duration });
  },

  /**
   * @param {string} message
   * @param {number} [duration]
   */
  showSuccess(message, duration) {
    this.show({ variant: 'success', message, duration });
  },
};
